import { Props } from "."

export const mockProps: Props = {
  size: "md",
  children: `The following quiz features a random selection of questions from all of the sections covered in the Linux module. The results will help you to identify the areas you are strongest and weakest in, and based on your results we will recommend the specific pages to revisit before moving onto the next module.`,
}
